<template>
	<div>
        <div class="theme-loader">
            <div class="ball-scale">
                <div class='contain'>
                    <img src="../assets/loader.gif">
                </div>
            </div>
        </div>
        <div id="pcoded" class="pcoded">
            <div class="pcoded-overlay-box"></div>
            <div class="pcoded-container navbar-wrapper">

                <navbar1 />

                <div class="pcoded-main-container">
                    <div class="pcoded-wrapper">
                        
                        <navbar2 />

                        <div class="pcoded-content">
                            <div class="pcoded-inner-content">
                                <div class="main-body">
                                    <div class="page-wrapper" style="background: #fff;">
                                        <div class="page-body">
                                            <h5 class="f-w-400 p-b-30">Create Offer Template</h5>
                                            <form v-on:submit.prevent="createTemplate">
                                                <div class="form-group">
                                                    <label>Opening:</label>
                                                    <select class="form-control" v-model="offer_template.joblisting_id">
                                                        <option v-for="o in opening" :key="o.id" v-bind:value="o.id">{{o.jobrole.name}}</option>
                                                    </select>
                                                </div>
                                                <div class="form-group">
                                                   <label>Template Name:</label>
                                                   <input type="text" class="form-control" v-model="offer_template.template_name" name="template_name" required="" />
                                                </div>
                                                <div class="form-group">
                                                    <label>Body:</label>
                                                    <summernote height="300" :model.sync="offer_template.body"></summernote>
                                                </div>
                                                <div class="form-group">
                                                   <input type="submit" name="submit" class="btn btn-primary" />
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import navbar1 from '../components/Navbar1.vue'
import navbar2 from '../components/Navbar2.vue'
import summernote from '../components/Summernote.vue'
import { bus } from '../main'
import roles from '../components/Roles'

export default {
    name: 'CreateOfferTemplate',

    data(){
        return{
            offer_template: {
                template_name:"",
                joblisting_id:"",
                body: ""
            },

            opening: ""
        }
    },

    components:{
        navbar1,
        navbar2,
        summernote,
        roles
    },

    mounted(){
        this.getAllOpenings()

        if(this.$route.params.id !== undefined){
            this.offer_template.joblisting_id = this.$route.params.id
        }
    },
    methods: {

        createTemplate: function(){

            let template = {
                what: 'CreateOfferTemplate',
                data: this.offer_template
            }

            this.$socket.makePostRequest(template)
                .then((response)=>{
                    if(response.type == "CreateOfferTemplate"){
                        this.$swal.fire("Success", "Template created.", 'success')
                    }
                })
                .catch((error)=>{
                    console.log(error)
                })
        },

        getAllOpenings(){

            var get_openings_request = {
                what: 'openings'
            }

            this.$socket.makeGetRequest(get_openings_request)
                .then((response)=>{
                    if(response.type == 'openings'){
                        this.opening = response.data
                    }
                })
                .catch((e)=>{
                    console.log(e)
                })
        }
            
    },
    computed: {
        
    }
}
</script>
